import {
  ArrowForwardIos, ContentCopy,
  Delete, Person
} from "@mui/icons-material";
import React, { memo } from "react";
import TextField from '@mui/material/TextField';
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";
import { Typography } from "@material-ui/core";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  console.log(12, "userNode", data)
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px",
        border: '1px solid rgba(76, 175, 80, 0.25)'
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#4caf50",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px",
          cursor: 'pointer'
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          minWidth: "150px"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px"
            }}
          >
            <Person
              sx={{
                color: "#4caf50",
                width: "20px",
                height: "20px"
              }}
            />
            <Typography
              variant="h6"
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#4caf50"
              }}
            >
              Usuário
            </Typography>
          </div>
          <div style={{ display: "flex", gap: "5px" }}>
            <ContentCopy
              onClick={() => {
                storageItems.setNodesStorage(id);
                storageItems.setAct("duplicate");
              }}
              sx={{
                color: "#757575",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                '&:hover': {
                  color: "#4caf50"
                }
              }}
            />
            <Delete
              onClick={() => {
                storageItems.setNodesStorage(id);
                storageItems.setAct("delete");
              }}
              sx={{
                color: "#757575",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                '&:hover': {
                  color: "#f44336"
                }
              }}
            />
          </div>
        </div>
        
        <div
          style={{
            padding: "8px",
            backgroundColor: "#f5f5f5",
            borderRadius: "4px",
            cursor: "pointer",
            border: "1px dashed #4caf50",
            minHeight: "40px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          {data && data.name ? (
            <div>
              <Typography
                variant="body2"
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#333",
                  marginBottom: "2px"
                }}
              >
                {data.name}
              </Typography>
              <Typography
                variant="caption"
                style={{
                  fontSize: "10px",
                  color: "#666"
                }}
              >
                {(data.email || '') + (data.profile ? ` • ${data.profile}` : '')}
              </Typography>
              {data.isOnline !== undefined && (
                <Typography
                  variant="caption"
                  style={{
                    fontSize: "10px",
                    color: data.isOnline ? "#4caf50" : "#757575",
                    display: "block",
                    marginTop: "2px"
                  }}
                >
                  {data.isOnline ? "Online" : "Offline"}
                </Typography>
              )}
              {Array.isArray(data.queues) && data.queues.length > 0 && (
                <div style={{ marginTop: '4px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {data.queues.slice(0,3).map(q => (
                    <span key={q.id} style={{
                      backgroundColor: q.color || '#4caf50',
                      color: '#fff',
                      borderRadius: '3px',
                      padding: '2px 4px',
                      fontSize: '9px'
                    }}>{q.name}</span>
                  ))}
                  {data.queues.length > 3 && (
                    <span style={{ fontSize: '9px', color: '#555' }}>+{data.queues.length - 3}</span>
                  )}
                </div>
              )}
            </div>
          ) : (
            <Typography
              variant="body2"
              style={{
                fontSize: "12px",
                color: "#999",
                textAlign: "center",
                fontStyle: "italic"
              }}
            >
              Clique para selecionar usuário
            </Typography>
          )}
        </div>
      </div>
      
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#4caf50",
          width: "18px",
          height: "18px",
          top: "20px",
          right: "-12px",
          cursor: 'pointer'
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "3.2px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
    </div>
  );
});
